<template>
  <div></div>
</template>

<script>
export default {
  name: 'RedirectPage',
  data() {
    return {
        path: this.$route.query.path || '',
    };
  },
  created() {
      if (this.path) {
          this.$router.push(this.path);
      } else {
          this.$router.go(-1);
      }
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
